import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Complaint from '.';
import { isPresent } from '../utils';

const WarrantyComplaint = ({ requiredFields, complainFunc, text, formData, showComplaints }) => {
  if (!showComplaints) {
    return null;
  }
  const fieldsArray = requiredFields.map(field => _.get(formData, field));
  const anyMissing = !_.every(fieldsArray, isPresent);
  const isComplaint = anyMissing || complainFunc(formData);

  return <Complaint text={text} show={isComplaint} />;
};

WarrantyComplaint.propTypes = {
  requiredFields: PropTypes.arrayOf(PropTypes.string),
  complainFunc: PropTypes.func, // true if it should complain
  text: PropTypes.string.isRequired,
  formData: PropTypes.object,
  showComplaints: PropTypes.bool,
};

WarrantyComplaint.defaultProps = {
  requiredFields: [],
  complainFunc: _formData => false,
};

const mapStateToProps = state => ({
  formData: state.formData,
  showComplaints: state.showComplaints,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyComplaint);
